import { EvtHeader } from "components/header";
import React from "react";
import { useParams } from "react-router-dom";
import JobTitleForm from "../form";

const UpdateJobTitle = () => {
  const { jobtitleId } = useParams();

  return (
    <div className="flex-1 max-w-md">
      <EvtHeader title="Update Job Title" />
      <div className="p-6 max-w-2xl">
        <JobTitleForm jobtitleId={jobtitleId} />
      </div>
    </div>
  );
};

export default UpdateJobTitle;
